export default __webpack_public_path__ + "static/media/kevin-durant-nets.c707c560.jpeg";